import type { ReactNode } from "react";

/**
 * Безопасно извлекает строку заголовка для legacy header API (только string/number).
 */
export function overlayTitleText(node: ReactNode, fallback = ""): string {
    if (typeof node === "string") {
        return node;
    }
    if (typeof node === "number") {
        return String(node);
    }
    return fallback;
}
